import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import NavMenu from "./NavMenu/NavMenu";
import NavMenuMobile from "./NavMenuMobile/NavMenuMobile";
import injectSheet from "react-jss";
import { ViewType } from "../../utils/Enums";
import Icon from "../../assets/icons/Icon";
import Tooltip from "../Tooltip/TooltipPopup";
import NavbarHeader from "./NavbarHeader/NavbarHeader";
import NotiserNavItem from "./NotiserNavItem";
import NavbarSearchbar from "./NavbarHeader/NavbarSearchbar";
import SamverkanspartItems from "./Items/SamverkanspartItems";
import { changeSelectedSmvp } from "../../redux/actions/user";
import { BookingIcon } from "../../assets/icons/Icons";

const Nav = ({
  visibles,
  classes,
  toggleSubmenu,
  logout,
  userState,
  changeSelectedSmvp,
}) => {
  const [visibleMobileMenu, setVisibleMobileMenu] = useState(false);
  const [hasNewPermission, setHasNewPermission] = useState(false);
  const [hasLokalAdminPermission, setHasLokalAdminPermission] = useState(false);
  const [submenuVisible, setSubmenuVisible] = useState(false);
  const [datatype, setDatatype] = useState("light");
  const [isMobile, setIsMobile] = useState(false);
  const toggleMobileMenu = () => setVisibleMobileMenu((v) => !v);
  const closeMobileMenu = () => setVisibleMobileMenu(false);

  useEffect(() => {
    var windowWidth = window.matchMedia("(max-width: 1023px)");
    checkDevice(windowWidth);
    const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
    if (isSafari) {
      windowWidth.addListener((value) => checkDevice(value));
    } else {
      windowWidth.addEventListener("change", checkDevice);
    }
    return () => {
      if (isSafari) {
        windowWidth.removeListener(() => checkDevice());
      } else {
        windowWidth.removeEventListener("change", checkDevice);
      }
    };
  }, []);

  useEffect(() => {
    if (userState) {
      setHasNewPermission(
        userState?.user?.allViews?.find((x) => x === ViewType.AttSkapa)
      );
    }
  }, [userState?.user?.allViews]);

  useEffect(() => {
    if (userState) {
      setHasLokalAdminPermission(
        userState?.user?.avdelnings?.some(
          (x) => x.internalUser && (x.permission & 128) === 128
        )
      );
    }
  }, [userState?.user?.avdelnings]);

  useEffect(() => {
    if (visibles) {
      setSubmenuVisible(visibles.some((x) => x === true));
    }
  }, [visibles]);

  useEffect(() => {
    if (submenuVisible) {
      setDatatype(submenuVisible ? "light" : "dark");
    }
  }, [submenuVisible]);

  function checkDevice(value) {
    setIsMobile(value.matches);
  }

  const showTopMenu = userState.samverkansparts?.some(
    (element) => element.administrator || element.lokalbokare
  );

  return (
    <>
      {isMobile ? (
        <nav className={classes.navMobile}>
          <NavLink
            style={{ backgroundColor: "white" }}
            onClick={closeMobileMenu}
            value="-1"
            data-toggle="popover"
            title="Hem"
            data-tooltip-content="Hem"
            to={!userState.selectedSamverkanspart ? "/" : "/samverkansparts"}
            exact
          >
            <Icon type="home" width="20px" height="17px" />
          </NavLink>
          <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between"}}>
            <span style={{ flex: 1}}>
              <NavbarSearchbar />
            </span>
            <div
              className="nav-bottom"
              style={{ display: "flex", alignItems: "center" }}
            >
              <NotiserNavItem
                toggleSubmenu={toggleSubmenu}
                visible={visibles[4]}
              />
              <button onClick={toggleMobileMenu}>
                <Icon type="menuBars" fill="white" width="24px" />
              </button>
            </div>
          </div>
        </nav>
      ) : (
        <>
          <nav
            className={classes.nav}
            style={{ marginTop: showTopMenu ? "86px" : "56px" }}
          >
            {!userState.selectedSamverkanspart ? (
              <>
                {hasNewPermission && (
                  <button
                    data-toggle="popover"
                    data-tooltip-content="Skapa arrangemang"
                    data-tooltip-id="navright"
                    data-tooltip-variant={datatype}
                    value="1"
                    className={visibles[1] ? classes.active : null}
                    onClick={toggleSubmenu}
                  >
                    <div>
                      <div className={classes.iconStyle}>
                        <Icon type="add" fill="white" width="24px" />
                      </div>
                      <div>Skapa</div>
                    </div>
                  </button>
                )}
                <button
                  data-toggle="popover"
                  data-tooltip-content="Hantera arrangemang"
                  data-tooltip-id="navright"
                  data-tooltip-variant={datatype}
                  data-cy="hantera-arr-btn"
                  value="2"
                  className={visibles[2] ? classes.active : null}
                  onClick={toggleSubmenu}
                >
                  <div>
                    <div className={classes.iconStyle}>
                      <Icon type="pen" fill="white" width="18px" />
                    </div>
                    <div>Hantera</div>
                  </div>
                </button>
                <button
                  data-toggle="popover"
                  data-tooltip-content="Visa arrangemang"
                  data-tooltip-id="navright"
                  data-tooltip-variant={datatype}
                  value="3"
                  className={visibles[3] ? classes.active : null}
                  onClick={toggleSubmenu}
                >
                  <div>
                    <div className={classes.iconStyle}>
                      <Icon
                        type="eye"
                        fill="white"
                        width="22px"
                        height="15px"
                      />
                    </div>
                    <div>Visa</div>
                  </div>
                </button>

                {hasLokalAdminPermission && (
                  <NavLink
                    onClick={toggleSubmenu}
                    data-tooltip-content="Hantera lokalbokning"
                    data-tooltip-id="navright"
                    data-place="right"
                    data-tooltip-variant={datatype}
                    to="/booking"
                    className={classes.button}
                  >
                    <div>
                      <div className={classes.iconStyle}>
                        <BookingIcon
                          size="24px"
                          color="white"
                          height="15px"
                          width="22px"
                        />
                      </div>
                      <div>Lokal&shy;bokning</div>
                    </div>
                  </NavLink>
                )}
              </>
            ) : (
              <SamverkanspartItems
                datatype={datatype}
                visibles={visibles}
                toggleSubmenu={toggleSubmenu}
                userState={userState}
              />
            )}
          </nav>
          <NavbarHeader
            userState={userState}
            changeSelectedSmvp={changeSelectedSmvp}
            visibles={visibles}
            toggleSubmenu={toggleSubmenu}
            logout={logout}
          />
        </>
      )}
      <NavMenu visibles={visibles} toggleSubmenu={toggleSubmenu} />
      <NavMenuMobile
        userState={userState}
        toggleMobileMenu={toggleMobileMenu}
        logout={logout}
        visible={visibleMobileMenu}
      />
      <Tooltip parent="nav" />
    </>
  );
};

const styles = (theme) => ({
  nav: {
    flex: "1",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    backgroundColor: theme.themeColor,
    zIndex: "7",
    height: "100%",
    width: "64px",
    marginTop: "56px",
    "&>button,&>a,& .nav-bottom>a": {
      border: "0",
      display: "flex",
      minHeight: "60px",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",

      wordBreak: "break-all",
      lineHeight: "1.0",

      cursor: "pointer",
      color: "white",
      fontSize: "11px",
      outline: "none",
      width: "100%",
      "&:hover": {
        "& svg g polygon": {
          fill: `${theme.themeHoverTextColor}!important`,
        },
        "& svg path": {
          fill: `${theme.themeHoverTextColor}!important`,
        },
        "& svg rect": {
          fill: `${theme.themeHoverTextColor}!important`,
        },
        backgroundColor: theme.themeHoverColor,
        color: theme.themeHoverTextColor,
      },
    },
  },
  active: {
    color: "white!important",
    background: theme.menuDarkColor + "!important",
  },
  button: {
    wordBreak: "break-word !important",
    textAlign: "center",
  },
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "5px",
  },
  navMobile: {
    display: "none",
  },
  "@media (max-width: 1023px)": {
    nav: { display: "none" },
    navMobile: {
      backgroundColor: theme.themeColor,
      height: "56px",
      display: "flex",
      position: "fixed",
      alignItems: "center",
      justifyContent: "space-between",
      top: "0",
      left: "0",
      right: "0",
      zIndex: "100",
      boxShadow: "5px 0 10px 0 rgba(255, 255, 255, 0)",
      "&>a": {
        border: "0",
        padding: "20px 20px",
        textAlign: "center",
        display: "inline-block",
        backgroundColor: "white",
        cursor: "pointer",
      },
      "& $emptyMobileNavElement": {
        flex: "2 0px",
      },
      "& .nav-bottom>button": {
        cursor: "pointer",
        padding: "16px 20px",
        color: "white",
        backgroundColor: "transparent",
        border: "0",
      },
    },
    emptyMobileNavElement: {},
  },
});

const mapStateToProps = (state) => {
  return {
    userState: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeSelectedSmvp: (value) => dispatch(changeSelectedSmvp(value)),
  };
};

const ConnectedNav = connect(mapStateToProps, mapDispatchToProps)(Nav);

export default injectSheet(styles)(ConnectedNav);
